export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  IsPrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  IsSameSummary: 'Cộng gộp các bút toán giống nhau',
  IsPrintHeaderAllPage: 'Lặp lại tiêu đề',
  ConfirmViewReport: 'Xem báo cáo',
};
